export const toggleState = {
    data() {
        return {
            isActive: false
        }
    },
    methods: {
        toggleState() {
            this.isActive = !this.isActive
        }
    },
    computed: {
        activeClass() {
            return this.isActive ? 'is-active' : null
        }
    }
}
